import { useState, useEffect } from 'react';

/**
 * useIsMobile - tracks whether the viewport currently matches the mobile
 * breakpoint (shared 768px cutoff used across the site's media queries).
 *
 * Prefer CSS media queries for styling; use this hook only where JSX must
 * render a different component tree (e.g. Dashboard's view-only stack).
 */
const useIsMobile = (query = '(max-width: 768px)') => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handleChange = (e) => setIsMobile(e.matches);
    // Older Safari only supports addListener/removeListener
    if (mql.addEventListener) {
      mql.addEventListener('change', handleChange);
    } else {
      mql.addListener(handleChange);
    }
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', handleChange);
      } else {
        mql.removeListener(handleChange);
      }
    };
  }, [query]);

  return isMobile;
};

export default useIsMobile;
